import React, { Component } from "react"
import { Link } from "gatsby"

class Header extends Component {    
  render() {
    let page = this.props.page
    return this.props.smallScreen ? (
      <header className="header">
        <Link to="/">
          <img src="https://res.cloudinary.com/barkandbreakfast/e_trim/logo-horz" alt="Bark &amp; Breakfast" className="logo-small"></img>
        </Link>
        <div className="divider"></div>
          <Link to="/">
            <button className={page === "home" ? "button-active" : "button"}>
              Home
            </button>
          </Link>
          <Link to="/boarding">
            <button className={page === "boarding" ? "button-active" : "button"}>
              Boarding
            </button>
          </Link>
          <Link to="/pictures">
            <button className={page === "pictures" ? "button-active" : "button"}>
              Pictures
            </button>
          </Link>
          <Link to="/contact">
            <button className={page === "contact" ? "button-active" : "button"}>
              Contact
            </button>
          </Link>
          <div className="divider"></div>
      </header>
    ) : (
      <header className="header">
        <Link to="/">
          <button className={page === "home" ? "button-active" : "button"}>
            Home
          </button>
        </Link>
        <Link to="/boarding">
          <button className={page === "boarding" ? "button-active" : "button"}>
            Boarding
          </button>
        </Link>
        <Link to="/">
          <img src="https://res.cloudinary.com/barkandbreakfast/e_trim/logo-vert" alt="Bark &amp; Breakfast" className="logo"></img>
        </Link>
        <Link to="/pictures">
          <button className={page === "pictures" ? "button-active" : "button"}>
            Pictures
          </button>
        </Link>
        <Link to="/contact">
          <button className={page === "contact" ? "button-active" : "button"}>
            Contact
          </button>
        </Link>
        <div className="divider"></div>
      </header>
    )
  }
}
export default Header
